<p-button
  [pTooltip]="tooltip()"
  [tooltipOptions]="tooltipOptions" 
  [disabled]="isDisabled()"
  (click)="onClick()"
  [label]="buttonLabel()"
  [styleClass]="buttonClasses()"
  [iconPos]="iconPos()"
  [ngClass]="additionalClasses()">

  <!-- icon -->
  <ng-template
    pTemplate="icon">
    <i
      [ngClass]="commandTemplate()?.settings?.icon">
    </i>
  </ng-template>
</p-button>  

